class TimeBasedAnnouncementBarTimer {
  constructor(root, countdownUntil) {
    this.root = root;
    this.countdownUntil = countdownUntil;
    this.tickerHour = document.createElement("span");
    this.tickerMinute = document.createElement("span");
    this.tickerSecond = document.createElement("span");

    while (root.hasChildNodes()) {
      root.removeChild(root.lastChild);
    }

    root.append(this.tickerHour, this.tickerMinute, this.tickerSecond);
    this.updateTicker();
  }

  updateTicker() {
    const now = new Date();
    const distance = this.countdownUntil - now;

    if (distance < 0) {
      return;
    }

    const hour = Math.floor(distance % (24 * 60 * 60 * 1000) / (60 * 60 * 1000));
    const minute = Math.floor(distance % (60 * 60 * 1000) / (60 * 1000));
    const second = Math.round(distance % (60 * 1000) / 1000);
    this.tickerHour.textContent = `${hour}h`;
    this.tickerMinute.textContent = `${minute}m`;
    this.tickerSecond.textContent = `${second}s`;

    const nextTick = new Date(now);
    nextTick.setSeconds(now.getSeconds() + 1, 0);
    setTimeout(this.updateTicker.bind(this), nextTick - now);
  }
}

class TimeBasedAnnouncementBar {
  constructor(root) {
    this.root = root;
    const settingsElement = root.querySelector(".time-based-announcement-bar--settings");
    this.settings = JSON.parse(settingsElement.textContent);
    this.bar = root.querySelector(".time-based-announcement-bar");
    this.paragraph = root.querySelector(".time-based-announcement-bar > p");
    TimeBasedAnnouncementBar.processSettings(this.settings);
    this.update();
  }

  static processSettings(settings) {
    if (settings.timeRanges[settings.timeRanges.length - 1] === null) {
      settings.timeRanges.pop();
    }
  }

  static createDateTime(timeStr, baseDate) {
    const tokens = timeStr.split(":");
    const hour = Number.parseInt(tokens[0], 10);
    const minute = Number.parseInt(tokens[1], 10);
    const date = new Date(baseDate);
    date.setHours(hour, minute, 0, 0);
    return date;
  }

  update() {
    const now = new Date();

    let i = -1;

    for (const timeRange of this.settings.timeRanges) {
      if (TimeBasedAnnouncementBar.createDateTime(timeRange.startTime, now) > now) {
        break;
      }

      i += 1;
    }

    if (i !== -1) {
      const next = i + 1;
      let nextStart = null;
      
      if (next === this.settings.timeRanges.length) {
        nextStart = new Date(now);
        nextStart.setHours(24, 0, 0, 0);
      } else {
        nextStart = TimeBasedAnnouncementBar.createDateTime(this.settings.timeRanges[next].startTime, now);
      }

      const targetTimeRange = this.settings.timeRanges[i];
      this.paragraph.innerHTML = targetTimeRange.message.replaceAll("[timer]", `<span class="timer"></span>`);
      this.bar.style.setProperty("--background-color", targetTimeRange.backgroundColor);

      let timerEndTime = nextStart;
      
      if (targetTimeRange.timerEndTime) {
        timerEndTime = TimeBasedAnnouncementBar.createDateTime(targetTimeRange.timerEndTime, now);
      }
      
      for (const timer of this.paragraph.querySelectorAll(".timer")) {
        timer.timer = new TimeBasedAnnouncementBarTimer(timer, timerEndTime);
      }

      const sleepLength = nextStart - now;
      setTimeout(this.update.bind(this), sleepLength);
    }
  }
}

(() => {
  function main() {
    for (const element of document.querySelectorAll(".shopify-section--time-based-announcement-bar")) {
      element.timeBasedAnnouncementBar = new TimeBasedAnnouncementBar(element);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main, { once: true });
  } else {
    main();
  }
})();
